import React from 'react';
import DialogWithPhoto from '@components/Popups/DialogWithPhoto';
import { messages, popupBanner } from './constants';

const RankPromotedSuccessPopUp = ({
  getUserCurrentRank,
  getUserCurrentRankText,
  isVisible,
  onPositiveClicked
}) => {
  return (
    <DialogWithPhoto
      visible={isVisible}
      titleText={`${getUserCurrentRankText}メンバーになりました！`}
      titleImage={popupBanner[getUserCurrentRank]}
      messages={messages[getUserCurrentRank]}
      positiveButtonTitle="OK"
      onPositiveClicked={onPositiveClicked}
    />
  );
};
export default RankPromotedSuccessPopUp;
